import { useEffect, useMemo } from 'react';
import { CanjeAction, CanjeStatus } from './useCanjeStatus';
import { LoginData } from '../../model/LoginData';
import { ProductoData } from '../../model/ProductoData';
import { Domicilio } from '../../model/Domicilio';
import { CanjeResponse } from '../../rest/CanjeResponse';
import { CanjeRequest } from '../../rest/CanjeRequest';
import { post } from '../../rest/api';
import { CanjeConfirmRequest } from '../../rest/CanjeConfirmRequest';
import { URL_API_CANJE, URL_API_CANJE_CONFIRM } from '../../constants/urls';
import { Phone } from '../../model/Phone';
import { DataOrigin } from './useDataInputSelect';
import { SmilesForm } from './useSmiles';
import { checkProductType } from './useValidateProductType';

export function useCanjeRequests(
  dispatch: React.Dispatch<CanjeAction>,
  loginData: LoginData | null,
  show: boolean,
  status: number,
  getPhone: () => Phone | undefined,
  getAddress: () => Domicilio | undefined,
  addressType: DataOrigin,
  otp: string | undefined,
  product: ProductoData | undefined,
  getSmilesForm: () => SmilesForm | undefined,
  onError: (reason?: any, errorCode?: number) => void,
  updateStock?: () => void
) {
  //Actualización de puntos y stock en caso de respuesta exitosa.
  const updatePoints = useMemo(
    () => () => {
      if (status === CanjeStatus.CANJE_EXITOSO - 2 || status === CanjeStatus.ERROR_OTP_STATUS) {
        loginData?.subtractPoints(product?.puntos);
        updateStock?.();
      }
    },
    [loginData, status, product?.puntos, updateStock]
  );

  //Callback para respuestas de canje partes 1 y 2.
  const responseRedeem = useMemo(
    () => (resp: CanjeResponse) => {
      if (!resp.token || !resp.expirationDate || !loginData?.updateToken) {
        onError();
        return;
      }
      loginData.updateToken(resp.token, resp.expirationDate);
      updatePoints();
      dispatch(CanjeAction.CONTINUAR);
    },
    [loginData, dispatch, updatePoints, onError]
  );

  //Canje parte 1
  useEffect(() => {
    if (show && status === CanjeStatus.INICIAL && checkProductType(product?.tipoProducto)) {
      dispatch(CanjeAction.CONTINUAR);

      const data: CanjeRequest = product?.productoId
        ? {
            id: product?.productoId.toString(),
          }
        : {};

      post(URL_API_CANJE, data, responseRedeem, onError, loginData);
    }
  }, [onError, dispatch, loginData, show, product, responseRedeem, status]);

  //Canje parte 2
  function sendForm() {
    dispatch(CanjeAction.CONTINUAR);

    let location: Domicilio | undefined;
    if (product?.esFisico()) {
      const address = getAddress();
      location = {
        ...address,
        isNew: addressType === DataOrigin.INPUT_DATA,
      };
    }

    const data: CanjeConfirmRequest = {
      otp: Number.parseInt(otp ?? ''),
      id: product?.productoId,
      telephone: getPhone()?.toString(),
      location: location,
      SmilesClient: getSmilesForm()?.clientNumber,
    };
    post(URL_API_CANJE_CONFIRM, data, responseRedeem, onError, loginData);
  }
  return sendForm;
}
